export default "__VITE_ASSET__BnAB0c8e__"